import { render, staticRenderFns } from "./ItemCardPrices.vue?vue&type=template&id=2b84bbb6&scoped=true"
import script from "./ItemCardPrices.vue?vue&type=script&lang=ts"
export * from "./ItemCardPrices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b84bbb6",
  null
  
)

export default component.exports